import apiHandler from "../core/apiHandler";

/**
 * 📚 API base para el historial
 * de cierres de caja (Corte Z)
 *
 * Endpoint:
 * /api/cash/closures/history
 */
const cashClosureHistoryApi = apiHandler("cash/closures/history");

export default cashClosureHistoryApi;
